import React from 'react';
import { CheckCircleIcon, HomeIcon } from 'lucide-react';
interface VictoryScreenProps {
  urgeBeatenCount: number;
  onGoHome: () => void;
}
export function VictoryScreen({
  urgeBeatenCount,
  onGoHome
}: VictoryScreenProps) {
  return <main className="flex flex-col items-center justify-center px-5 pt-16 pb-32 min-h-screen islamic-pattern" data-id="element-175">
      {/* Success icon */}
      <div className="w-20 h-20 rounded-full bg-success/20 flex items-center justify-center mb-6" data-id="element-176">
        <CheckCircleIcon className="w-10 h-10 text-success" data-id="element-177" />
      </div>

      {/* Main message */}
      <h1 className="text-2xl font-bold text-foreground text-center mb-3" data-id="element-178">
        You beat this urge. Alhamdulillah.
      </h1>
      <p className="text-base text-muted-foreground text-center leading-relaxed max-w-xs mb-8" data-id="element-179">
        That took real strength, brother. Allah sees your effort.
      </p>

      {/* Urge count */}
      <div className="bg-card rounded-lg border border-border p-5 w-full max-w-xs text-center mb-10" data-id="element-180">
        <p className="text-sm text-muted-foreground mb-1" data-id="element-181">You've beaten</p>
        <p className="text-4xl font-bold text-primary mb-1" data-id="element-182">
          {urgeBeatenCount}
        </p>
        <p className="text-sm text-muted-foreground" data-id="element-183">
          {urgeBeatenCount === 1 ? 'urge' : 'urges'}
        </p>
      </div>

      {/* Gentle ayah */}
      <div className="text-center mb-10 max-w-xs" data-id="element-184">
        <p className="font-arabic text-xl text-primary leading-loose mb-2" dir="rtl" data-id="element-185">
          إِنَّ مَعَ الْعُسْرِ يُسْرًا
        </p>
        <p className="text-sm text-muted-foreground italic" data-id="element-186">
          "Verily, with hardship comes ease."
        </p>
        <p className="text-xs text-muted-foreground mt-1" data-id="element-187">
          — Surah Ash-Sharh (94:6)
        </p>
      </div>

      {/* Go home button */}
      <button onClick={onGoHome} className="bg-secondary text-secondary-foreground font-medium text-base rounded-lg py-3 px-8 min-h-[48px] border border-border hover:bg-muted active:scale-[0.98] transition-all duration-150 flex items-center gap-2" aria-label="Go back to home screen" data-id="element-188">
        <HomeIcon className="w-5 h-5" data-id="element-189" />
        Go home
      </button>
    </main>;
}